<template>
  <b-modal
    :visible="value"
    title="Chọn thiết bị"
    @hide="closeModal"
    size="xl"
    ignore-enforce-focus-selector="input"
  >
    <!-- content -->
    <div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="card-header m-b-10">
          <form class="box-search" @submit.prevent="submitForm">
            <div class="form-group">
              <input
                type="text"
                v-model.trim="search.key"
                class="form-control f12 hc-37 text-search"
                placeholder="Serial/tên MC/gmail MC/SĐT"
                @keyup.enter="submitForm"
              />
            </div>

            <div class="form-group">
              <Select2
                v-model="search.emailSale"
                :options="Config.getSearch(optionsListUserByEmail)"
                placeholder="CVKD"
              />
            </div>

            <div class="form-group">
              <Select2
                v-model="search.status"
                :options="Config.getSearch(Config.statusDeviceKpi)"
                placeholder="Trạng thái"
                disabled
              >
              </Select2>
            </div>

            <div class="form-group form-group-action">
              <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
                <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
              </button>
              <button
                type="button"
                class="btn btn-outline-light hc-37 mr-2 pt-2"
                @click="removeForm"
              >
                <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
              </button>
            </div>
          </form>
        </div>
        <div class="card-body">
          <div class="tab-content" id="nav-tabContent">
            <div class="p-10">
              Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
              <span v-if="selectedIds.length"> - đã chọn {{ selectedIds.length }}</span>
              <b-table
                :busy.sync="tbLoading"
                sticky-header
                responsive
                hover
                :items="lists"
                :fields="filterTable"
                :fixed="true"
                :bordered="true"
                style="max-height: calc(100vh - 400px)"
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #head(selected)>
                  <b-form-checkbox
                    :disabled="tbLoading"
                    v-model="selectAll"
                    @change="onChangeAll"
                  ></b-form-checkbox>
                </template>
                <template #cell(selected)="data">
                  <b-form-checkbox
                    class="text-center"
                    v-model="selectedIds"
                    :value="data.item.id"
                  ></b-form-checkbox>
                </template>
                <template #cell(merchantEmail)="data">
                  <p><b>Tên:</b> {{ data.item.merchantName }}</p>
                  <p><b>Email:</b> {{ data.item.merchantEmail }}</p>
                  <p><b>SĐT:</b> {{ data.item.merchantMobile }}</p>
                  <p><b>Địa chỉ:</b> {{ data.item.merchantAddress }}</p>
                </template>
                <template #cell(emailSale)="data">
                  <p><b>Tên:</b> {{ data.item.nameSale }}</p>
                  <p><b>Email:</b> {{ data.item.emailSale }}</p>
                </template>
                <template #cell(packageType)="data">
                  <p v-if="data.item.packageType">Loại gói: {{ data.item.packageType }}</p>
                  <p v-if="data.item.duration">Thời hạn: {{ data.item.duration }}</p>
                </template>
                <template #cell(status)="data">
                  <span class="badge" :class="data.item.status">
                    {{ data.item.status | transformData(Config.statusDeviceKpi) }}
                  </span>
                </template>
              </b-table>
            </div>
          </div>
          <div class="pagination-bottom">
            <b-pagination
              v-model="search.page"
              :total-rows="pagination.total"
              :per-page="search.limit"
              class="fl-right mr-2"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="" @click="closeModal" class="mr-2"> Huỷ bỏ </b-button>
        <b-button variant="primary" @click="submit" :disabled="selectedIds.length === 0">
          Xác nhận
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  // import { StaffService } from '@/services/staff.service'
  import { getListUserFnByEmail } from '../kpiRecordMx'

  const rawSearch = {
    emailSale: null,
    key: null,
    limit: 20,
    page: 1,
  }
  const fieldsTable = [
    { key: 'selected', label: '', thStyle: '' },
    { key: 'service', label: 'Dịch vụ', thStyle: '' },
    { key: 'merchantEmail', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'contractCode', label: 'Mã hợp đồng', thStyle: '' },
    { key: 'appendixCode', label: 'Mã phụ lục', thStyle: '' },
    { key: 'serial', label: 'Serial TB', thStyle: '' },
    // packageType/duration
    { key: 'packageType', label: 'Loại gói & Thời hạn' },
    { key: 'emailSale', label: 'CVKD', thStyle: 'min-width: 170px' },
    { key: 'status', label: 'Trạng thái', thStyle: '' },
  ]

  export default {
    props: ['value', 'statusKpi', 'kpiFileUploadId', 'creatorId', 'actionModalSelectDevice'],
    data() {
      return {
        moment,
        Config,
        filterTable: fieldsTable,
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: cloneDeep(rawSearch),
        pagination: {
          total: 0,
        },
        lists: [],

        optionsListUserByEmail: [],
        selectedIds: [],
        selectAll: false,
      }
    },
    created() {
      this.search.status = [this.statusKpi]
      this.fetchData()
      this.getListUser()
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async submit() {
        console.log(this.selectedIds)
        if (this.selectedIds.length === 0) return
        this.$emit('submit', this.selectedIds, this.statusKpi, this.actionModalSelectDevice)
      },

      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      removeForm() {
        this.search = { ...this.search, ...cloneDeep(rawSearch) }
        this.fetchData()
      },
      onChangeAll() {
        if (this.lists.length === 0) return
        if (this.selectAll) {
          this.lists.map(item => {
            this.selectedIds.push(item.id)
          })
          this.selectedIds = [...new Set(this.selectedIds)]
        } else {
          const ids = []
          this.lists.map(item => {
            ids.push(item.id)
          })
          this.selectedIds = this.selectedIds.filter(id => {
            console.log(!ids.includes(id), ids, id)
            return !ids.includes(id)
          })
        }
      },

      async getListUser() {
        this.optionsListUserByEmail = await getListUserFnByEmail()
      },
      async fetchData() {
        console.log('fetch data')
        this.selectAll = false
        try {
          this.tbLoading = true
          const params = {
            ...rawSearch,
            ...this.search,
          }
          // if has kpiFileUploadId
          if (this.kpiFileUploadId) {
            params.kpiFileUploadId = this.kpiFileUploadId
          }
          // if has creatorId
          if (this.creatorId) {
            params.creatorId = this.creatorId
          }
          // remove data null and '0'
          for (const key in params) {
            if (
              params[key] === null ||
              params[key] === '0' ||
              (Array.isArray(params[key]) && params[key].length === 0)
            ) {
              delete params[key]
              delete this.search[key]
            }
          }
          // console.log(params)
          const response = await DeviceService.deviceKpiGetList(params)
          if (response.code === 1000) {
            this.lists = response.data.kpiAggregateRes
            this.pagination.total = response.data.count
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style></style>
